import axios from '@/utils/axios';

// 商品列表
export function GoodsList(page, limit, type) {
    return axios({
        url: '/goods/list',
        method: 'get',
        params: { page, limit, type },
    });
}

// 商品详情
export function GoodsDetail(goodsId) {
    return axios({
        url: '/goods',
        method: 'get',
        params: { goodsId },
    });
}

// 根据城市（默认地址）显示商品(传递用户id)
export function GoodsListByCity(page, limit, addressId, type) {
    return axios({
        url: '/goods/list/city',
        method: 'get',
        params: { page, limit ,addressId, type},
    });
}

// 根据城市显示商品(传递完整的用户地址)
export function GoodsListByAddress(page, limit, address) {
    return axios({
        url: '/goods/list/address',
        method: 'get',
        params: { page, limit ,address},
    });
}